<div class="card">
  <div class="card-body">
    <ng-container *ngTemplateOutlet="InvoiceTemplateSituationDeduction"></ng-container>
  </div>
  <div class="card-footer" fxLayout="row" fxFlex="100" fxLayoutAlign="center" fxLayoutGap="10px" *ngIf="this.invoiceDetailModel.Deductions?.length > 0">
    <div fxLayout="column" fxFlex="100" fxLayoutAlign="start">
      <ng-container *ngTemplateOutlet="InvoiceTemplateDeductionsDetailSum"></ng-container>
    </div>
  </div>
</div>

<ng-template #InvoiceTemplateSituationDeduction>
  <div fxLayout="column">
    <div fxLayout="row" fxFlex="100" fxLayoutAlign="start" fxLayoutGap="10px">
      <div class="card-header-detail">RETENUE :</div>
      <button mat-icon-button color="accent" (click)="addDeduction()" *ngIf="!isReadOnlyFormOrWaiting">
        <mat-icon>add_circle</mat-icon>
      </button>
    </div>

    <div fxLayout="row" fxFlex="100" fxLayoutAlign="start" fxLayoutGap="10px">
      <ng-container *ngTemplateOutlet="InvoiceTemplateDeductionDetail"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #InvoiceTemplateDeductionDetail>
  <form [formGroup]="invoiceDetailForm" fxLayout="column" fxFlex="100" fxLayoutAlign="start">
    <ng-container formArrayName="InvoiceDeductions">
      <div fxLayout="column" fxFlex="100" fxLayoutAlign="start">
        <ng-container *ngFor="let DeductionForm of InvoiceDeductions.controls; let i = index">
          <div [formGroup]="DeductionForm" fxLayout="column" fxFlex="100" fxLayoutAlign="start">
            <div fxLayout="row" fxFlex="100" fxLayoutAlign="start" fxLayoutGap="10px" [ngClass]="InvoiceDeductions.length == (i+1) ? 'customWrapper' : 'customDefaultWrapper'">
              <div fxFlex="20" fxFlex.gt-sm="20" fxLayoutGap="10px">
                <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100" *ngIf="DeductionForm.controls['DeductionTypeCode'].disabled">
                  <mat-label>TYPE DE LA RETENUE </mat-label>
                  <input matInput formControlName="DeductionTypeLabelReadOnly" type="text" required readonly>
                </mat-form-field>
                <div class="dropDownStyle" *ngIf="!DeductionForm.controls['DeductionTypeCode'].disabled" fxFlex="100">
                  <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" floatLabel="always">
                    <mat-label>TYPE DE LA RETENUE </mat-label>
                    <input matInput formControlName="DeductionTypeCode" type="text" required hidden>
                    <ng-multiselect-dropdown placeholder='Sélectionner' [ngClass]="{ 'is-invalid': submitted && DeductionForm.errors, 'edited-color': editedDropdowns.includes('ExpenseVat')}"
                      [settings]="dropDownSettingsDeductionType" [data]="dropDownDataDeductionType" formControlName="DeductionTypeLabel"
                      [(ngModel)]="DeductionForm.controls.SelectedDeductionType.value" (onSelect)="onChangeDeductionType(i, DeductionForm.controls.CreatedAt.value, $event)"
                      (onDeSelect)="onChangeDeductionType(i, DeductionForm.controls.CreatedAt.value, null)" ngDefaultControl>
                    </ng-multiselect-dropdown>
                  </mat-form-field>
                </div>
              </div>
              <div fxFlex="18" fxFlex.gt-sm="18" fxLayoutGap="10px">
                <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100">
                  <mat-label>% RETENU </mat-label>
                  <input matInput formControlName="DeductionPercentage" type="text" [style]="commonLibrary.getSumClass()">
                </mat-form-field>
              </div>
              <div fxFlex="20" fxFlex.gt-sm="20" fxLayoutGap="10px">
                <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100">
                  <mat-label>PROVISION TTC </mat-label>
                  <input matInput formControlName="AmountProvisionedTaxExcluded" type="text" decimalFormat pattern="[0-9\s+]+([,\.][0-9]{0,2})?" step="0.01"
                    (change)="setAmountOnDeduction(i, DeductionForm.controls.CreatedAt.value, 'AmountProvisionedTaxExcluded')">
                </mat-form-field>
              </div>
              <div fxFlex="20" fxFlex.gt-sm="20" fxLayoutGap="10px">
                <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100">
                  <mat-label>LIB&Eacute;R&Eacute;E TTC </mat-label>
                  <input matInput formControlName="AmountReleasedTaxExcluded" type="text" decimalFormat pattern="[0-9\s+]+([,\.][0-9]{0,2})?" step="0.01"
                    (change)="setAmountOnDeduction(i, DeductionForm.controls.CreatedAt.value, 'AmountReleasedTaxExcluded')">
                </mat-form-field>
              </div>
              <div fxFlex="20" fxFlex.gt-sm="20" fxLayoutGap="10px">
                <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100">
                  <mat-label>CONSERV&Eacute;E TTC </mat-label>
                  <input matInput formControlName="AmountRetainedTaxExcluded" type="text" decimalFormat pattern="[0-9\s+]+([,\.][0-9]{0,2})?" step="0.01"
                    (change)="setAmountOnDeduction(i, DeductionForm.controls.CreatedAt.value, 'AmountRetainedTaxExcluded')">
                </mat-form-field>
              </div>
              <div fxFlex="2" fxFlex.gt-sm="2">
                <button mat-icon-button color="accent" (click)="deleteDeduction(i, DeductionForm.controls.CreatedAt.value)" *ngIf="!isReadOnlyFormOrWaiting">
                  <mat-icon>remove_circle</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </form>
</ng-template>

<ng-template #InvoiceTemplateDeductionsDetailSum>
  <div fxLayout="row" fxFlex="100" fxLayoutAlign="start" fxLayoutGap="10px" class="no-wrapper">
    <div fxFlex="38" fxLayoutAlign="start center" fxFlex.gt-sm="38" fxLayoutGap="10px">
      <h2>TOTAL DES RETENUES</h2>
    </div>
    <div fxFlex="60" fxFlex.gt-sm="60" fxLayoutGap="10px">
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="33" fxFlex.gt-sm="33">
        <mat-label>PROVISION TTC </mat-label>
        <input matInput value="{{invoiceDetailAmountCalc.deductionsSumProvisionedTaxExcluded}}" type="text" decimalFormat pattern="[0-9\s+]+([,\.][0-9]{0,2})?" step="0.01" disabled
          [style]="commonLibrary.getSumClass()">
      </mat-form-field>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="33" fxFlex.gt-sm="33">
        <mat-label>LIB&Eacute;R&Eacute;E TTC </mat-label>
        <input matInput value="{{invoiceDetailAmountCalc.deductionsSumReleasedTaxExcluded}}" type="text" decimalFormat pattern="[0-9\s+]+([,\.][0-9]{0,2})?" step="0.01" disabled
          [style]="commonLibrary.getSumClass()">
      </mat-form-field>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="33" fxFlex.gt-sm="33">
        <mat-label>CONSERV&Eacute;E TTC </mat-label>
        <input matInput value="{{invoiceDetailAmountCalc.deductionsSumRetainedTaxExcluded}}" type="text" decimalFormat pattern="[0-9\s+]+([,\.][0-9]{0,2})?" step="0.01" disabled
          [style]="commonLibrary.getSumClass()">
      </mat-form-field>
    </div>
    <div fxFlex="2" fxFlex.gt-sm="2" fxLayoutGap="10px">
    </div>
  </div>
</ng-template>